export const REQUEST_COMPENSATORY_TIME_OFF_CREATE_PATH =
  "/requests/compensatory-time-off/create";

export const REQUEST_COMPENSATORY_TIME_OFF_EDIT_PATH =
  "/requests/compensatory-time-off/edit/:id";
